export default "__VITE_ASSET__CDv1O0Tr__"